import { render, staticRenderFns } from "./create-extend-package.vue?vue&type=template&id=50f9b445&scoped=true"
import script from "./create-extend-package.vue?vue&type=script&lang=js"
export * from "./create-extend-package.vue?vue&type=script&lang=js"
import style0 from "./create-extend-package.vue?vue&type=style&index=0&id=50f9b445&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f9b445",
  null
  
)

export default component.exports